import {FormattedMessage} from 'react-intl';
import {ReactComponent as Icon} from '../../assets/send-mail-icon-1.svg';
import {useButtonSendChatHistoryContext} from '../../contexts';
import styles from './ButtonSendChatHistory.module.scss';

const ButtonSendChatHistory = () => {
  const {toggleQuestion, isDisabled} = useButtonSendChatHistoryContext();

  return (
      <button
        type="button"
        className="btn btn-send-mail-primary"
        onClick={toggleQuestion}
        disabled={isDisabled}
      >
        {Icon && (
          <div className="d-flex justify-content-between my-1">
            <Icon width={32} height={32} className={styles.icon}/>
            <span className="d-inline-flex align-items-center px-1 text-white">
              <FormattedMessage
                id="chat-btn-send-mail-label"
                defaultMessage="Sending a summary by email"
              />
            </span>
          </div>
        )}
      </button>
  );
};

export default ButtonSendChatHistory;
